module.exports = __webpack_public_path__ + "img/survey-man.5942b1fc.png";